import React from 'react'
import ConsultationTypes from './components/ConsultationTypes'

function GetConsultationTypes() {
  return (
    <>
      <ConsultationTypes />
    </>
  )
}

export default GetConsultationTypes